// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + chunkId + "." + {"default-libs_core_src_lib_services_date_date_service_ts-libs_core_src_lib_tokens_unleash-flag-8d7a3b":"c404a88731405fdf","libs_wl_westpac_src_lib_gift-card_gift-card-wrapper_module_ts":"c4033983aa649231","apps_stg_src_app_offer_offer-wrapper_module_ts":"abdb56b5105fcf5e"}[chunkId] + ".js";
};